//declare permette di "aggiungere" al dizionario typescript delle keyword in modo da permettere la compilazione  
//anche quando non presenti nell'environment
declare var require: any; //non presente nei progetti web. In compilazione si ha l'errore "Cannot find name 'require'."
declare var global: any;  //non presente nei progetti web. In compilazione si ha l'errore "Cannot find name 'global'."

import { logger } from './logger';

/**
 * Costruisce un url montando opportunamente i frammenti specificati in input 
 * @param urlPrefixInfo object that contains the fields protocol, domain, port and contextPath
 * @param urlPath array of string 
 * @param urlParams array of string key=value
 */
export const buildUrl = (urlPrefixInfo, urlPath?, urlParams?) => {
    try {
        let url = urlPrefixInfo.protocol+"://"+urlPrefixInfo.domain+":"+urlPrefixInfo.port;
    
        if(urlPrefixInfo.contextPath)
            url+="/"+urlPrefixInfo.contextPath;

        if(urlPath)
            urlPath.forEach(element => url+="/"+element);

        if(urlParams){
            let first = true;
            urlParams.forEach(element => {
                url+=first?"?"+element:"&"+element;
                first = false;
            });
        }

        return url;
        
    } catch (error) {
        logger.error(`buildUrl() - urlPrefixInfo: ${urlPrefixInfo} - urlPath: ${urlPath} - urlParams: ${urlParams} -  Error: ${error}`);
        throw error; 
    }
}

/**
 * Costruisce un path concatenando con l'opportuno separatore (in base all'OS) i frammenti specificati in input.
 * Se il primo parametro inizia con '.' lo trasforma in path assoluto utilizzando 'process.cwd()'
 * @param fragments 
 */
export const buildPath = (...fragments: any[]) => {
    try {
        const fragmentsAsArray = [].slice.call(fragments);
        let atomicFragments = [];
        fragmentsAsArray.forEach(element => {
            if(Array.isArray(element))
                atomicFragments = atomicFragments.concat(element)
            else
                atomicFragments.push(element+'')
        });

        const pathFragments = atomicFragments.map((item, index) => {
            if(require("process").platform=='win32')
                (item+'').split('/').join('\\')
            // Se il primo frammento inizia per '.' monta il path assoluto, altrimenti lo lascia invariato
            return (index==0 /*solo il primo frammento*/ && (item+'').startsWith(".")) ? `${require("process").cwd()}${(item+'').substr(1)}` : item
        });
        
        return require("path").join.apply(require("path"), pathFragments);
    
    } catch (error) {
        logger.error(`buildPath(${fragments}) -  Error: ${error}`);
        throw error; 
    }
}